"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processDeclarationFonts = exports.findFontsInCss = exports.findFontsInAst = void 0;
var fonts_1 = __importDefault(require("santa-core-utils/dist/fonts"));
var core_1 = require("@stylable/core");
var parseValues = require('css-selector-tokenizer').parseValues;
var isUploadedFontFamily = fonts_1.default.isUploadedFontFamily, getShortUploadedFontFamily = fonts_1.default.getShortUploadedFontFamily;
/*******************************************************************/
/* This logic should be added to Stylable, and imported from there */
/*******************************************************************/
function findFontsInAst(root, filter, onlyUploaded) {
    if (filter === void 0) { filter = function () { return true; }; }
    if (onlyUploaded === void 0) { onlyUploaded = false; }
    var fontsSet = new Set();
    root.walkDecls(function (decl) {
        if (!filter(decl)) {
            return;
        }
        processDeclarationFonts(decl, function (font) {
            fontsSet.add(font);
        });
    });
    var fontsArray = Array.from(fontsSet);
    if (onlyUploaded) {
        fontsArray = fontsArray.filter(function (fontName) { return isUploadedFontFamily(fontName); })
            .map(function (font) { return font + "," + getShortUploadedFontFamily(font); });
    }
    return fontsArray;
}
exports.findFontsInAst = findFontsInAst;
function findFontsInCss(css, declFilter, onlyUploaded) {
    if (declFilter === void 0) { declFilter = function () { return true; }; }
    return findFontsInAst(core_1.safeParse(css), declFilter, onlyUploaded);
}
exports.findFontsInCss = findFontsInCss;
function processDeclarationFonts(decl, onFont) {
    // Run only for font props:
    if (decl.prop !== 'font' && decl.prop !== 'font-family') {
        return;
    }
    var ast = parseValues(decl.value);
    ast.nodes.forEach(function (node, index) {
        var nodes = node.nodes;
        var lastChild = nodes[nodes.length - 1];
        if (lastChild) {
            // font is always last. commas split to different nodes, so this assumption holds for multiple fonts as well
            var type = lastChild.type;
            switch (type) {
                case 'item':
                    if (decl.prop === 'font' && index === 0) {
                        if (lastChild.name) {
                            onFont(lastChild.name);
                        }
                    }
                    else {
                        var font = nodes.reduce(function (fontAgg, part) {
                            return "" + fontAgg + part.name + (part.after ? part.after : '');
                        }, '');
                        onFont(font);
                    }
                    break;
                case 'string':
                    if (lastChild.value && !(lastChild.value === "\"\"" || lastChild.value === "''")) {
                        onFont(lastChild.value);
                    }
                    break;
            }
        }
    });
}
exports.processDeclarationFonts = processDeclarationFonts;
//# sourceMappingURL=fonts-stylable.js.map